export const logOutDictionary = {
  logOut: 'Вы точно хотите выйти?',
  exit: 'Выход',
}
